import { LinkProps } from '@components/atoms/Link/Link';
import LINKS from '@constants/links';
import usePageHasSideNav from '@hooks/usePageHasSideNav';
import useTranslation from 'next-translate/useTranslation';
import { SkipContainer, SkipLink } from './SkipToContent.styles';
import { SKIP_TO_CONTENT_MAIN_ID, SKIP_TO_CONTENT_PAGE_CONTENT_ID, SKIP_TO_CONTENT_SEARCH_FIELD_ID } from './constants';

const AnchorElement = (props: LinkProps) => {
  return <SkipLink {...props} external />;
};

const SkipToContent = () => {
  const pageHasSideNav = usePageHasSideNav();
  const { t } = useTranslation('common');

  const targetDiv = pageHasSideNav ? SKIP_TO_CONTENT_PAGE_CONTENT_ID : SKIP_TO_CONTENT_MAIN_ID;

  const handleFocus = (e: LinkClickEvent, target: string) => {
    e.preventDefault();
    const el = document.getElementById(target);
    !!el && el.focus({ preventScroll: true });
  };

  return (
    <SkipContainer>
      <AnchorElement onClick={(e) => handleFocus(e, targetDiv)} href={`#${targetDiv}`}>
        {t('skipToContent->toContentText')}
      </AnchorElement>

      <SkipLink href={LINKS.ACCESSIBILITY_STATEMENT}>{t('skipToContent->accessibilityLinkText')}</SkipLink>

      <AnchorElement
        onClick={(e) => handleFocus(e, SKIP_TO_CONTENT_SEARCH_FIELD_ID)}
        href={`#${SKIP_TO_CONTENT_SEARCH_FIELD_ID}`}
      >
        {t('skipToContent->toSearchText')}
      </AnchorElement>
    </SkipContainer>
  );
};

export default SkipToContent;
